module.exports = __webpack_public_path__ + "static/media/wmcp.fd967902.png";